import { useFormContext } from '@calendly/form'
import { useEffect } from 'react'

import { useEnforceUpgrade } from 'components/billing/useEnforceUpgrade'
import { usePrevious } from 'hooks/usePrevious'

export const CheckCanUnbrand = () => {
  const { values: { showCalendlyBranding }, setFieldValue } = useFormContext()
  const previousBranded = usePrevious(showCalendlyBranding)

  const enforceUpgrade = useEnforceUpgrade('unbranding', { paywall: 'general_account_settings_branding' })

  useEffect(
    () => {
      if (showCalendlyBranding || showCalendlyBranding === previousBranded) return

      setFieldValue('showCalendlyBranding', true)
      enforceUpgrade(() => setFieldValue('showCalendlyBranding', false))
    },
    [showCalendlyBranding, enforceUpgrade, previousBranded, setFieldValue]
  )

  return null
}
